import { render, staticRenderFns } from "./EditEvent.vue?vue&type=template&id=5b822d8f"
import script from "./EditEvent.vue?vue&type=script&lang=js"
export * from "./EditEvent.vue?vue&type=script&lang=js"
import style0 from "./EditEvent.vue?vue&type=style&index=0&id=5b822d8f&prod&lang=scss"
import style1 from "./EditEvent.vue?vue&type=style&index=1&id=5b822d8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports